import { Permission } from '@procureai/permissions';
import { usePermissions } from '@procureai/permissions-ui';
import { PageHeaderStatic, PageTitle } from '@procureai/ui-mui';
import { Navigate } from 'react-router-dom';

import { PageLayout } from '~/components/PageLayout/PageLayout';
import { RouteId } from '~/routes/RouteId';

export const Analytics = () => {
  const { hasPermission } = usePermissions();

  return hasPermission(Permission.BaseGeneral) ? (
    <Navigate to={RouteId.analyticsGeneral} replace />
  ) : (
    <PageLayout
      fullHeight
      renderHeader={<PageHeaderStatic title={<PageTitle title="Analytics" />} maxWidth={false} />}
    />
  );
};
